import styled from 'styled-components';

export const Form = styled.form`
  width: 100%;
  margin-top: 12px;
`;
